export default function XLogo(props) {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M17.6761 4.24268H20.4362L14.4061 11.0201L21.5 20.2427H15.9456L11.5951 14.6493L6.61723 20.2427H3.85544L10.3052 12.9935L3.5 4.24268H9.19545L13.1279 9.3553L17.6761 4.24268ZM16.7073 18.6181H18.2368L8.36441 5.78196H6.7232L16.7073 18.6181Z" fill="#FDFDFD"/>
</svg>

  )
}
